module.exports = __webpack_public_path__ + "img/img_flecha_desc.58e08747.svg";